export default __webpack_public_path__ + "static/media/undo.3e744b44.svg";